<div class="tr md-no-proxy layout-row layout-align-start-center">

  <!--AI Agent Name-->
  <div class="td flex-15 layout-row layout-align-start-center">
    <span class="text-ellipsis">{{ aiAgent.name }}</span>
  </div>

  <!--Description-->
  <div class="td flex layout-row layout-align-start-center">
    <span class="text-ellipsis" [ngbTooltip]="aiAgent.description" triggers="hover"
          container="body">{{ aiAgent.description }}</span>
  </div>

  <!--Active-->
  <div class="td flex-5 layout-row layout-align-start-center">
    <span class="text-ellipsis">{{ aiAgent.active }}</span>
  </div>

  <!--Created At-->
  <div class="td flex-10 layout-row layout-align-start-center">
    {{ aiAgent | bringozFullDate: 'createdAt'}}
  </div>

  <!--Updated At-->
  <div class="td flex-10 layout-row layout-align-start-center">
    {{ aiAgent | bringozFullDate: 'updatedAt'}}
  </div>

  <!--Actions-->
  <div class="td flex-5 layout-row layout-align-start-center">
    <div *ngIf="allowEdit">
<!--      <bringoz-button *ngxPermissionsOnly="'aiAgent.update'"-->
      <bringoz-button type="tertiary"
                      (onClick)="editAiAgentEvent.emit(aiAgent)">
        <bringoz-icon iconName="edit-outline" classSize="lg" fill="#424242"></bringoz-icon>
      </bringoz-button>
    </div>

    <div *ngIf="allowDelete" class="margin-left-5">
<!--      <bringoz-button *ngxPermissionsOnly="'aiAgent.delete'"-->
      <bringoz-button type="tertiary"
                      (onClick)="deleteAiAgentEvent.emit(aiAgent)">
        <bringoz-icon iconName="trash" classSize="lg" fill="#424242"></bringoz-icon>
      </bringoz-button>
    </div>

  </div>
</div>
